import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=5dc9b8f2&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=ts"
export * from "./ProductsTable.vue?vue&type=script&lang=ts"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=5dc9b8f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9b8f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dc9b8f2')) {
      api.createRecord('5dc9b8f2', component.options)
    } else {
      api.reload('5dc9b8f2', component.options)
    }
    module.hot.accept("./ProductsTable.vue?vue&type=template&id=5dc9b8f2&scoped=true", function () {
      api.rerender('5dc9b8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ProductsTable.vue"
export default component.exports